<template>
  <BaseDialogNew
    v-model="visible"
    class="w-full max-w-xl"
  >
    <BaseEntityForm
      width-class="max-w-xl"
      :isDialogForm="true"
      slim
    >
      <template #title>
        <BaseFormHeader
          :isDialogForm="true"
          :subtitle="$t('Create & edit statuses for all projects.')"
        >
          <template #title>
            <h3 class="text-2xl font-bold">
              <span
                class="mr-1 underline"
                :class="{
                  'text-green-500': !$useNewLayout,
                  'text-white': $useNewLayout,
                }"
              >
                {{ $t('Account Level') }}
              </span>
              {{ $t('Project Statuses') }}
            </h3>
          </template>
        </BaseFormHeader>
      </template>
      <template #default="{ meta, errors }">
        <ProjectStatuses
          class="project-statuses-container"
          :isDialogForm="true"
        />
      </template>
      <template #actions="{ meta, errors }">
        <BaseButton
          variant="white"
          @click="visible = false"
        >
          {{ $t('Close') }}
        </BaseButton>
      </template>
    </BaseEntityForm>
  </BaseDialogNew>
</template>
<script>
import ProjectStatuses from "@/modules/accounts/pages/project-statuses.vue";

export default {
  components: {
    ProjectStatuses,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
}
</script>
<style scoped>
.project-statuses-container {
  @apply border-none;
}
</style>
